module.exports = __webpack_public_path__ + "static/media/VaishnaviCircle.c9d49c4f.jpg";